import { atom } from "recoil";
import { Dtc } from "../types";
export const dtcListState = atom<Dtc[]>({
  key: "dtcListState",
  default: [],
});